var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M17.875 11c0-.21-.01-.412-.028-.623l1.705-1.293a.922.922 0 0 0 .239-1.191l-1.714-2.961a.905.905 0 0 0-1.146-.385l-1.971.834a6.949 6.949 0 0 0-1.073-.623l-.265-2.118a.92.92 0 0 0-.908-.807h-3.42a.922.922 0 0 0-.916.807l-.266 2.118a6.954 6.954 0 0 0-1.072.623l-1.97-.834a.905.905 0 0 0-1.147.385L2.21 7.902a.924.924 0 0 0 .238 1.191l1.705 1.293a6.727 6.727 0 0 0 0 1.237l-1.705 1.293a.922.922 0 0 0-.238 1.191l1.714 2.961a.905.905 0 0 0 1.146.385l1.97-.834c.34.239.698.45 1.073.623l.266 2.118a.92.92 0 0 0 .908.807h3.419a.92.92 0 0 0 .907-.807l.266-2.117a6.955 6.955 0 0 0 1.073-.624l1.97.834a.905.905 0 0 0 1.146-.385l1.715-2.96a.924.924 0 0 0-.239-1.192l-1.705-1.293a4.74 4.74 0 0 0 .037-.623Zm-6.838 3.208A3.212 3.212 0 0 1 7.828 11c0-1.77 1.44-3.208 3.209-3.208 1.769 0 3.208 1.439 3.208 3.208 0 1.77-1.44 3.208-3.208 3.208Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 11,
    x2: 11,
    y1: 1.833,
    y2: 20.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B51E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#720ECF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.e6d6a896d80d66d6db1be53388208e16.svg";
export { ForwardRef as ReactComponent };